import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import LoadUnloadService from '../../services/LoadUnloadService';
import MdrService from '../../services/MdrService';
import { isNullOrEmpty, translate, showMessageToast } from '../../utils/util';
import MvmInfo from './MvmInfo';

const StartLoadUnload = (props) => {
    const [mvm, setMvm] = useState('');

    const onStartLoadUnloadMVMClick = () => {
        document.getElementById('tabStartLoadUnload').click();

        if (isNullOrEmpty(props.user.vision)) {
            showMessageToast({ html: translate('select-vision', 'validations'), classes: 'red' });
            return;
        }

        if (!props.shed || props.shed === '') {
            showMessageToast({ html: translate('select-shed', 'validations'), classes: 'red' });
            return;
        }

        if (!props.movementType || props.movementType === '') {
            showMessageToast({ html: translate('select-dock', 'validations'), classes: 'red' });
            return;
        }

        if (isNullOrEmpty(mvm)) {
            showMessageToast({ html: translate('inf-mvm', 'physical-confirmation'), classes: 'red' });
        } else {
            props.clearAll();
            props.clearMdrList();
            props.clearConfirmationMdrList();
            let model = { mvm, sheds: [] };
            model.mvm = mvm;
            model.movementDescription = props.movementTypeObj?.movementType.description || '';
            model.shedCode = props.shedObj?.code || '';
            model.shedId = parseInt(props.shed);
            model.movementTypeId = props.movementType;
            props.startShedLoad(model, (responseData) => {
                if (props.onRead) {
                    props.onRead();
                }
                props.loadShedConfigs();
            });
        }
    }

    return (
        <div>
            <div className="container-fluid h-65" />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '0px', paddingTop: '8px' }}>
                        <div className="row">
                            <div className="col s9">
                                <div className="form-group">
                                    <div className="input-field">
                                        <MvmInfo mvm={props.mvm} />
                                        <input
                                            id="mvm"
                                            name="mvm"
                                            placeholder={translate('type-mvm', 'physical-confirmation')}
                                            type="number"
                                            defaultValue={!isNullOrEmpty(mvm) ? mvm : props.mvm.mvmNumber}
                                            onChange={(el) => setMvm(el.target.value)}
                                            onBlur={(el) => setMvm(el.target.value)}
                                            onKeyDown={(event) => { if (event.key === 'Enter') onStartLoadUnloadMVMClick(); }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col s3 center">
                                <span className="input-group-btn">
                                    <button
                                        className="btn-floating btn-large btn-principal waves-effect waves-light"
                                        type="button"
                                        onClick={onStartLoadUnloadMVMClick}
                                    >
                                        <i className="material-icons">search</i>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        mvm: state.loadUnloadReducer.mvm,
        user: state.userReducer.user,
        config: state.configReducer.config,
        shed: state.loadUnloadReducer.shed,
        shedObj: state.loadUnloadReducer.shedObj,
        movementType: state.loadUnloadReducer.movementType,
        movementTypeObj: state.loadUnloadReducer.movementTypeObj,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        startShedLoad: (model, callback) => {
            dispatch(LoadUnloadService.startShedLoad(model, callback));
        },
        clearMdrList: () => {
            dispatch(MdrService.clearMdrList());
        },
        clearConfirmationMdrList: () => {
            dispatch(LoadUnloadService.clearConfirmationMdrList());
        },
        loadShedConfigs: (callback) => {
            dispatch(LoadUnloadService.getShedsConfig(callback, false));
        },
        clearAll: () => {
            dispatch(LoadUnloadService.clearAll());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StartLoadUnload));
